import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function AvatarSection() {
  const items = ['You get erections alone or in the morning… but with her, it disappears.', 'One bad night created a fear that now arrives before anything else.', 'You rush things because you\'re afraid your body will "change its mind."', 'You\'ve tried pills, supplements, porn, breaks, "confidence techniques"… and you still can\'t control the moment.', "You don't want to talk about this for six months with a therapist. You want something you can use tonight."];
  return <section className="py-12 md:py-16 px-4 sm:px-6" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-6 text-center text-text-primary" data-id="element-39">
          If any of these statements are true for you, this is exactly for you:
        </h2>

        <img src="https://cdn.magicpatterns.com/uploads/9VYXZrop89c57KSQpQz1JM/heylloyd-image-1773372806821.png" alt="Man sitting on edge of bed" className="w-full max-w-2xl mx-auto h-auto rounded-xl border border-dark-border shadow-lg mb-8" data-id="element-40" />

        <div className="space-y-2 mb-8" data-id="element-41">
          {items.map((item, index) => <div key={index} className="flex items-start gap-2.5 bg-dark-card px-4 py-3 rounded-lg border border-dark-border hover:border-gold/30 transition-colors" data-id="element-42">
              <CheckCircle2 className="w-4 h-4 text-gold flex-shrink-0 mt-0.5" data-id="element-43" />
              <p className="text-sm text-text-secondary leading-snug" data-id="element-44">{item}</p>
            </div>)}
        </div>

        <p className="text-2xl md:text-3xl font-playfair font-bold text-gold text-center" data-id="element-45">
          This guide exists for you.
        </p>
      </div>
    </section>;
}